import React, { useEffect,useState, useRef } from 'react';
import { CircularProgress } from "@material-ui/core";

import ChatLoader from "../../utils/LoaderComponent/ChatLoader";
import { s360ConfigService } from "../Services/S360Config";

import Message from "./MessageBoxTypes/Message";

import "./ConversationStyleSheet.css";
import MessageS1 from './MessageCodes/MessageS1';

const AlwaysScrollToBottom = () => {
  const elementRef = useRef();
  useEffect(() => {
    elementRef.current?.scrollIntoView()
  });

  return <div ref={elementRef} />;
};

function Conversation(props) {
  const messages = props.messages || [];
  const isFetchingMessages = props.isFetchingMessages || false;
  const isFetchingMessagesBelow = props.isFetchingMessagesBelow || false;
  const isLoaderEnabled = s360ConfigService.config.enableLoader || false;
  const isFullScreen = localStorage.getItem("openInFullScreen");
  const customDesign = props.config?.customDesign ?? {};
  const {isShowLanguageDropdown, setIsShowLanguageDropdown,selectedLanguage, setSelectedLanguage} = props;
  //  console.log(s360ConfigService,!s360ConfigService.config.sandbox,isShowLanguageDropdown,selectedLanguage,'sandbox')
  // useEffect(() => {

  // }, []);
  return (
    <div className={`s360-conversation${isFullScreen ? "-fs" : ""}`} id="s360-conversation-chat">
      {isFetchingMessages && (
        <div className="s360-message-container-activity-indicator"
          style={customDesign?.messageContainerActivityIndicator}>
          <CircularProgress color="inherit" size={20} />
        </div>
      )}
      {s360ConfigService.config.showLanguageToggle && <MessageS1 sessionId={props.sessionId} isShowLanguageDropdown={isShowLanguageDropdown} setIsShowLanguageDropdown={setIsShowLanguageDropdown} selectedLanguage={selectedLanguage} setSelectedLanguage={setSelectedLanguage} {...props}/>}
      {!isShowLanguageDropdown &&
       messages.map((message) => (
        <Message
          {...props}
          message={message}
          key={message.id}
          startNewConversation={props.startNewConversation}
          handleCustomerRetryMsg={props.handleCustomerRetryMsg}
        />
      ))}
      <AlwaysScrollToBottom />

      {!props.disableLoader && isLoaderEnabled && isFetchingMessagesBelow && (
        <div className="s360-message-container-activity-indicator" style={customDesign?.messageContainerActivityIndicator}>
          <ChatLoader/>
        </div>
      )}
    </div>
  );
}

export default Conversation;
